import Icon from 'atoms/icon';
import Tooltip from 'deprecated/atoms/simpleTooltip';
import * as React from 'react';
import { pointerDirection } from 'types';
import classNames from 'utils/classNames';
import './triggeredTooltip.css';

interface TriggeredTooltipStateInterface {
  isOpen: boolean;
  iconPosition: {
    top: number;
    left: number;
    bottom: number;
    right: number;
    x: number;
    y: number;
    width: number;
    height: number;
  } | null;
}

interface TriggeredTooltipPropsInterface {
  children: JSX.Element | JSX.Element[];
  disabled?: boolean;
  disableOnHover?: boolean;
  forceClose?: boolean;
  closeOnOutsideClick?: boolean;
  glyph?: any;
  icon?: React.ReactElement<any>;
  placement?: pointerDirection;
  onClick?: (openState: boolean) => any;
  toggleOnClick?: boolean;
  onMouseEnter?: () => any;
  onMouseLeave?: () => any;
  offsets?: {
    top?: number;
    left?: number;
    bottom?: number;
    right?: number;
  };
  theme?: string;
  className?: string;
  pointerPlacement?: boolean;
  style?: { [prop: string]: any };
}

export default class TriggeredTooltip extends React.Component<
  TriggeredTooltipPropsInterface,
  TriggeredTooltipStateInterface
> {
  constructor(props) {
    super(props);

    this.state = {
      iconPosition: null,
      isOpen: false,
    };
  }

  public componentDidUpdate(prevProps, prevState) {
    if (this.props.forceClose && !prevProps.forceClose) {
      this.setState({ isOpen: false });
    }
  }
  private iconRef: React.RefObject<any> = React.createRef();

  public componentDidMount() {
    this.setState({
      iconPosition: this.iconRef.current.getBoundingClientRect(),
    });
  }

  private onClick = e => {
    if (!this.props.disabled) {
      const openState = !this.state.isOpen;
      if (
        this.props.toggleOnClick !== undefined ? this.props.toggleOnClick : true
      ) {
        this.setState({
          iconPosition: this.iconRef.current.getBoundingClientRect(),
          isOpen: openState,
        });
      }

      if (this.props.onClick) {
        this.props.onClick(openState);
      }
    }
  };

  private onMouseEnter = e => {
    if (!this.props.disableOnHover) {
      this.setState({
        iconPosition: this.iconRef.current.getBoundingClientRect(),
        isOpen: true,
      });
      if (this.props.onMouseEnter) {
        this.props.onMouseEnter();
      }
    }
  };

  private onMouseLeave = e => {
    if (!this.props.disableOnHover) {
      this.setState({
        isOpen: false,
      });

      if (this.props.onMouseLeave) {
        this.props.onMouseLeave();
      }
    }
  };

  private onOutsideClick = target => {
    if (
      this.props.closeOnOutsideClick &&
      this.state.isOpen &&
      !this.iconRef.current.contains(target)
    ) {
      this.setState({
        isOpen: false,
      });
    }
  };

  public render() {
    const {
      children,
      icon,
      placement = 'top',
      glyph,
      disabled,
      offsets,
      theme,
      pointerPlacement = true,
      className,
      style = { width: 'fit-content' },
    } = this.props;

    const { isOpen, iconPosition } = this.state;
    const { top = 0, left = 0, width = 0, height = 0 } = iconPosition || {};

    return (
      <>
        <div
          className={classNames({
            triggeredIconContainer: true,
            [className]: !!className,
          })}
          style={style}
          onClick={this.onClick}
          ref={this.iconRef}
        >
          {glyph ? (
            <Icon glyph={icon} className="defaultTriggeredIcon" />
          ) : (
            React.cloneElement(icon, {
              ...(disabled
                ? {
                    className: classNames({
                      ...(icon.props.className
                        ? { [icon.props.className]: true }
                        : {}),
                      disabled,
                    }),
                  }
                : {
                    className: classNames({
                      ...(icon.props.className
                        ? { [icon.props.className]: true }
                        : {}),
                    }),
                    onClick: this.onClick,
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                  }),
            })
          )}
        </div>
        {isOpen && (
          <Tooltip
            placement={placement}
            position={{ top, left }}
            width={width}
            height={height}
            theme={theme}
            toolTipOffsets={offsets}
            isShown={isOpen}
            pointerPlacement={pointerPlacement}
            onOutsideClick={this.onOutsideClick}
          >
            {children}
          </Tooltip>
        )}
      </>
    );
  }
}
